// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "6363") return "6363.59d82c4e6.bundle.js";
  // return url for filenames based on template
  return "" + (chunkId === "3992" ? "pagerules" : chunkId) + ".59d82c4e6.chunk.js"
}